<template>
  <div>
    <div class="close-btn">
      <router-link to="/globalLogicEditView">
        <i class="fa fa-times"></i>
      </router-link>
    </div>
    <div class="panel-wrapper">
      <div class="col">
        <div class="logic-wrapper inspector-wrap">
          <h4 class="mr-3 mb-5">
            Add New Condition
          </h4>
          <div v-for="(logicitem, index) in logic_fields" :key="index" class="mb-3">
            <div class="fields-wrapper">
              <div class="row align-items-center">
                <div class="col-12">
                  <div class="logic-fields-wrap">
                    <div class="logic-item">
                      <label>Logic Type</label>
                      <select class="custom-select" v-model="logicitem.logicNode.condition_type">
                        <option v-for="(item, key) in options.condition_type" :value="item.key">{{ item.value }}</option>
                      </select>
                    </div>
                    <template v-if="logicitem.logicNode.condition_type == 'touch'">
                      <div class="logic-item" v-if="logicitem.logicNode.condition_type">
                        <label>Type</label>
                        <select class="custom-select" v-model="logicitem.logicNode.logic_type">
                          <option v-for="item in options.logic_type[logicitem.logicNode.condition_type]" :value="item.key">{{
                              item.value
                            }}
                          </option>
                        </select>
                      </div>
                      <div class="logic-item" v-if="logicitem.logicNode.logic_type">
                        <label>{{ logicitem.logic_type == 'scene' ? 'Object' : 'Media' }} Type</label>
                        <select class="custom-select" v-model="logicitem.logicNode.media_type">
                          <option v-for="item in options.media_type[logicitem.logicNode.logic_type]" :value="item.key">{{
                              item.value
                            }}
                          </option>
                        </select>
                      </div>

                      <template v-if="logicitem.logicNode.logic_type == 'scene'">
                        <div class="logic-item" v-if="logicitem.logicNode.logic_type">
                          <label>Asset</label>
                          <select class="custom-select" v-model="logicitem.logicNode.object_type">
                            <option v-for="item in options.object_type[logicitem.logicNode.media_type]" :value="item.key">
                              {{
                                item.value
                              }}
                            </option>
                          </select>
                        </div>
                      </template>

                      <div class="logic-item" v-if="logicitem.logicNode.media_type">
                        <label>Interaction Type</label>
                        <select class="custom-select" v-model="logicitem.logicNode.interaction_type">
                          <option
                            v-for="item in options.interaction_type[logicitem.logicNode.object_type ? logicitem.logicNode.object_type : logicitem.logicNode.media_type]"
                            :value="item.key">{{
                              item.value
                            }}
                          </option>
                        </select>
                      </div>
                      <div class="logic-item"
                           v-if="logicitem.logicNode.interaction_type == 'swipe' || logicitem.logicNode.interaction_type == 'tap'">


                        <div class="dropdown">
                          <button class="btn btn-white dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Decision
                          </button>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <div class="form-check select-single" v-for="item in options.decision_type[logicitem.logicNode.interaction_type]">
                              <label>
                              <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="logicitem.logicNode.decision"
                                :value="item.key"
                              />
                              {{
                                item.value
                              }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="logicitem.logicNode.condition_type == 'probability'">
                      <div class="logic-item" v-if="logicitem.logicNode.condition_type">
                        <label>Number of Scenes</label>
                        <input
                          class="form-control"
                          min="0"
                          max="100"
                          maxlength="3"
                          pattern="\d*"
                          type="text"
                          v-model="logicitem.logicNode.no_of_scenes"
                        />
                      </div>
                      <div class="logic-item" v-if="logicitem.logicNode.no_of_scenes > 0">
                        <label>Percentage</label>
                        <div class="input-group mb-0" v-for="index in parseInt(logicitem.logicNode.no_of_scenes)"
                             :key="index">
                          <input
                            class="form-control"
                            min="0"
                            max="100"
                            maxlength="2"
                            pattern="\d*"
                            type="text"
                            readonly
                            v-model="logicitem.logicNode.percentage[index] = (100 / logicitem.logicNode.no_of_scenes).toFixed(2)"
                          />
                          <div class="input-group-append">
                            <span class="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <div class="logic-item">
                      <template v-if="logicitem.logicNode.decision || logicitem.logicNode.no_of_scenes">
                        <div>
                          <button class="btn btn-outline-primary">Inspector</button>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="logic_fields.length" class="row form-group mt-4">
            <div class="col-12 text-center">
              <button class="btn btn-primary" @click="saveToDB()">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {uuid} from 'vue-uuid'

export default {
  components: {},
  data () {
    return {
      activeComponent: 'globalLogic',
      logic_fields: [],

      options: {
        condition_type: [
          {key: 'verbal', value: 'Verbal'},
          {key: 'non-verbal', value: 'Non-Verbal'},
          {key: 'touch', value: 'Touch'},
          {key: 'event', value: 'Event'},
          {key: 'probability', value: 'Probability'}
        ],
        logic_type: {
          'verbal': [],
          'non-verbal': [],
          'touch': [{key: 'scene', value: 'Scene'}, {key: 'screen', value: 'Screen'}],
          'event': [],
          'probability': []
        },
        media_type: {
          'scene': [{key: '3d', value: '3d'}, {key: 'media', value: 'media'}],
          'screen': [{key: 'image', value: 'Image'}, {key: 'video', value: 'Video'}]
        },
        object_type: {
          '3d': [{key: 'character', value: 'Character'}, {key: 'object3d', value: 'Object 3D'}],
          'media': [{key: 'image', value: 'Image'}, {key: 'video', value: 'Video'}]
        },
        interaction_type: {
          'image': [{key: 'swipe', value: 'swipe'}, {key: 'tap', value: 'tap'}],
          'video': [{key: 'pause', value: 'pause'}, {key: 'play', value: 'play'}],
          'object3d': [{key: 'swipe', value: 'swipe'}, {key: 'tap', value: 'tap'}],
          'character': [{key: 'swipe', value: 'swipe'}, {key: 'tap', value: 'tap'}]
        },
        decision_type: {
          'swipe': [{key: 'up', value: 'up'}, {key: 'right', value: 'right'}, {
            key: 'down',
            value: 'down'
          }, {key: 'left', value: 'left'}],
          'tap': [{key: 'tap', value: 'tap'}, {key: 'double-tap', value: 'double tap'}, {
            key: 'triple-tap',
            value: 'triple tap'
          }, {key: 'hold', value: 'hold'}],
        },
        path: ['Scene 1', 'Scene 2', 'Scene 3', 'Scene 4']
      },
      media_names: [],

      selectAll: false,
      isSelected: false,
      currentIndex: null
    }
  },
  created () {
  },
  mounted () {
    console.log('this.$store.selectedLogic', this.$store.state.selectedLogic)

    this.addNewLogic()
  },

  methods: {
    addNewLogic () {
      const index = this.logic_fields.length ? this.logic_fields.length - 1 : 0
      this.logic_fields.push({
        elementType: 'LogicNode',
        id: uuid.v1(),
        logicNode: {
          condition_type: '',
          logic_type: '',
          object_type: '',
          media_type: '',
          media_name: '',
          interaction_type: '',
          decision: [],
          path: 'new',

          no_of_scenes: 0,
          percentage: [],

          isCopied: false,
          selectSingle: false
        }
      })
    },

    deleteLogic (key, item) {
      var idx = this.logic_fields.indexOf(item)
      if (idx > -1) {
        this.logic_fields.splice(idx, 1)
      }
    },
    copyLogic (index, item) {
      this.logic_fields[index].logicNode.isCopied = !this.logic_fields[index].logicNode.isCopied
      this.logic_fields.push({
        elementType: 'LogicNode',
        id: uuid.v1(),
        logicNode: {}
      })
    },
    deleteAllLogic () {
      this.logic_fields = this.logic_fields.filter(value => {
        return !value.logicNode.selectSingle
      })
    },
    checkSingleSelect () {
      this.logic_fields.forEach(value => {
        if (value.logicNode.selectSingle) {
          this.isSelected = true
        }
      })
    },
  },
  watch: {
    selectAll: function (val) {
      this.isSelected = !!val
      if (this.logic_fields) {
        this.logic_fields.forEach(value => {
          value.logicNode.selectSingle = val
        })
      }
    }
  },
  computed: {}
}
</script>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/global-logic-components/globalLogic.vue